import { type ActiveDatabaseStream, DatabaseStreamState } from '@databases/rovo-bridge';
import { useEffect, useState } from 'react';

export type DatabaseStreamHookState = {
  isStreaming: boolean;
  operationType?: 'create' | 'edit';
  activeStream: ActiveDatabaseStream | null;
};

/**
 * A hook for observing the Databases streaming status from the bridge API by subscribing to DatabaseStreamState
 * Returns the current streaming status and identifies the active stream type.
 */
export const useDatabaseStreamState = (): DatabaseStreamHookState => {
  const [state, setState] = useState<DatabaseStreamHookState>(
    () => DatabaseStreamState.getInstance().snapshot
  );

  useEffect(() => {
    const unsubscribe = DatabaseStreamState.getInstance().subscribe((s) => {
      setState(s);
    });
    return unsubscribe;
  }, []);

  return state;
};
